import { jsxs as v, jsx as y } from "react/jsx-runtime";
import { g as T } from "./_commonjsHelpers-DaMA6jEr.js";
import { a as d, b as E, i as O, _ as w, c as H } from "./isObject-CiJutytu.js";
import { tv as F } from "tailwind-variants";
import { a as G } from "./index.esm-wEvHxvCe.js";
import j from "../Icon.js";
var A = Array.isArray, g = A, K = g, R = d, L = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, q = /^\w*$/;
function J(t, e) {
  if (K(t))
    return !1;
  var a = typeof t;
  return a == "number" || a == "symbol" || a == "boolean" || t == null || R(t) ? !0 : q.test(t) || !L.test(t) || e != null && t in Object(e);
}
var U = J, V = E, X = O, Z = "[object AsyncFunction]", Y = "[object Function]", B = "[object GeneratorFunction]", Q = "[object Proxy]";
function W(t) {
  if (!X(t))
    return !1;
  var e = V(t);
  return e == Y || e == B || e == Z || e == Q;
}
var k = W, tt = w, et = tt["__core-js_shared__"], at = et, f = at, C = function() {
  var t = /[^.]+$/.exec(f && f.keys && f.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function rt(t) {
  return !!C && C in t;
}
var nt = rt, st = Function.prototype, it = st.toString;
function ot(t) {
  if (t != null) {
    try {
      return it.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var ct = ot, ht = k, lt = nt, ut = O, pt = ct, _t = /[\\^$.*+?()[\]{}|]/g, vt = /^\[object .+?Constructor\]$/, ft = Function.prototype, dt = Object.prototype, gt = ft.toString, mt = dt.hasOwnProperty, $t = RegExp(
  "^" + gt.call(mt).replace(_t, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function yt(t) {
  if (!ut(t) || lt(t))
    return !1;
  var e = ht(t) ? $t : vt;
  return e.test(pt(t));
}
var Ct = yt;
function bt(t, e) {
  return t == null ? void 0 : t[e];
}
var St = bt, xt = Ct, Pt = St;
function Mt(t, e) {
  var a = Pt(t, e);
  return xt(a) ? a : void 0;
}
var D = Mt, Ot = D, wt = Ot(Object, "create"), l = wt, b = l;
function Dt() {
  this.__data__ = b ? b(null) : {}, this.size = 0;
}
var It = Dt;
function Nt(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var zt = Nt, Tt = l, Et = "__lodash_hash_undefined__", Ht = Object.prototype, Ft = Ht.hasOwnProperty;
function Gt(t) {
  var e = this.__data__;
  if (Tt) {
    var a = e[t];
    return a === Et ? void 0 : a;
  }
  return Ft.call(e, t) ? e[t] : void 0;
}
var jt = Gt, At = l, Kt = Object.prototype, Rt = Kt.hasOwnProperty;
function Lt(t) {
  var e = this.__data__;
  return At ? e[t] !== void 0 : Rt.call(e, t);
}
var qt = Lt, Jt = l, Ut = "__lodash_hash_undefined__";
function Vt(t, e) {
  var a = this.__data__;
  return this.size += this.has(t) ? 0 : 1, a[t] = Jt && e === void 0 ? Ut : e, this;
}
var Xt = Vt, Zt = It, Yt = zt, Bt = jt, Qt = qt, Wt = Xt;
function o(t) {
  var e = -1, a = t == null ? 0 : t.length;
  for (this.clear(); ++e < a; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
o.prototype.clear = Zt;
o.prototype.delete = Yt;
o.prototype.get = Bt;
o.prototype.has = Qt;
o.prototype.set = Wt;
var kt = o;
function te() {
  this.__data__ = [], this.size = 0;
}
var ee = te;
function ae(t, e) {
  return t === e || t !== t && e !== e;
}
var re = ae, ne = re;
function se(t, e) {
  for (var a = t.length; a--; )
    if (ne(t[a][0], e))
      return a;
  return -1;
}
var u = se, ie = u, oe = Array.prototype, ce = oe.splice;
function he(t) {
  var e = this.__data__, a = ie(e, t);
  if (a < 0)
    return !1;
  var r = e.length - 1;
  return a == r ? e.pop() : ce.call(e, a, 1), --this.size, !0;
}
var le = he, ue = u;
function pe(t) {
  var e = this.__data__, a = ue(e, t);
  return a < 0 ? void 0 : e[a][1];
}
var _e = pe, ve = u;
function fe(t) {
  return ve(this.__data__, t) > -1;
}
var de = fe, ge = u;
function me(t, e) {
  var a = this.__data__, r = ge(a, t);
  return r < 0 ? (++this.size, a.push([t, e])) : a[r][1] = e, this;
}
var $e = me, ye = ee, Ce = le, be = _e, Se = de, xe = $e;
function c(t) {
  var e = -1, a = t == null ? 0 : t.length;
  for (this.clear(); ++e < a; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
c.prototype.clear = ye;
c.prototype.delete = Ce;
c.prototype.get = be;
c.prototype.has = Se;
c.prototype.set = xe;
var Pe = c, Me = D, Oe = w, we = Me(Oe, "Map"), De = we, S = kt, Ie = Pe, Ne = De;
function ze() {
  this.size = 0, this.__data__ = {
    hash: new S(),
    map: new (Ne || Ie)(),
    string: new S()
  };
}
var Te = ze;
function Ee(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
var He = Ee, Fe = He;
function Ge(t, e) {
  var a = t.__data__;
  return Fe(e) ? a[typeof e == "string" ? "string" : "hash"] : a.map;
}
var p = Ge, je = p;
function Ae(t) {
  var e = je(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
var Ke = Ae, Re = p;
function Le(t) {
  return Re(this, t).get(t);
}
var qe = Le, Je = p;
function Ue(t) {
  return Je(this, t).has(t);
}
var Ve = Ue, Xe = p;
function Ze(t, e) {
  var a = Xe(this, t), r = a.size;
  return a.set(t, e), this.size += a.size == r ? 0 : 1, this;
}
var Ye = Ze, Be = Te, Qe = Ke, We = qe, ke = Ve, ta = Ye;
function h(t) {
  var e = -1, a = t == null ? 0 : t.length;
  for (this.clear(); ++e < a; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
h.prototype.clear = Be;
h.prototype.delete = Qe;
h.prototype.get = We;
h.prototype.has = ke;
h.prototype.set = ta;
var ea = h, I = ea, aa = "Expected a function";
function m(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(aa);
  var a = function() {
    var r = arguments, n = e ? e.apply(this, r) : r[0], s = a.cache;
    if (s.has(n))
      return s.get(n);
    var i = t.apply(this, r);
    return a.cache = s.set(n, i) || s, i;
  };
  return a.cache = new (m.Cache || I)(), a;
}
m.Cache = I;
var ra = m, na = ra, sa = 500;
function ia(t) {
  var e = na(t, function(r) {
    return a.size === sa && a.clear(), r;
  }), a = e.cache;
  return e;
}
var oa = ia, ca = oa, ha = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, la = /\\(\\)?/g, ua = ca(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(ha, function(a, r, n, s) {
    e.push(n ? s.replace(la, "$1") : r || a);
  }), e;
}), pa = ua;
function _a(t, e) {
  for (var a = -1, r = t == null ? 0 : t.length, n = Array(r); ++a < r; )
    n[a] = e(t[a], a, t);
  return n;
}
var va = _a, x = H, fa = va, da = g, ga = d, P = x ? x.prototype : void 0, M = P ? P.toString : void 0;
function N(t) {
  if (typeof t == "string")
    return t;
  if (da(t))
    return fa(t, N) + "";
  if (ga(t))
    return M ? M.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -1 / 0 ? "-0" : e;
}
var ma = N, $a = ma;
function ya(t) {
  return t == null ? "" : $a(t);
}
var Ca = ya, ba = g, Sa = U, xa = pa, Pa = Ca;
function Ma(t, e) {
  return ba(t) ? t : Sa(t, e) ? [t] : xa(Pa(t));
}
var Oa = Ma, wa = d;
function Da(t) {
  if (typeof t == "string" || wa(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -1 / 0 ? "-0" : e;
}
var Ia = Da, Na = Oa, za = Ia;
function Ta(t, e) {
  e = Na(e, t);
  for (var a = 0, r = e.length; t != null && a < r; )
    t = t[za(e[a++])];
  return a && a == r ? t : void 0;
}
var Ea = Ta, Ha = Ea;
function Fa(t, e, a) {
  var r = t == null ? void 0 : Ha(t, e);
  return r === void 0 ? a : r;
}
var Ga = Fa;
const ja = /* @__PURE__ */ T(Ga), z = F({
  slots: {
    base: ["flex", "justify-between", "text-sm"],
    error: ["text-rose-600"],
    info: ["font-primary", "ml-auto"]
  }
}), { base: Aa, error: Ka, info: Ra } = z(), La = ({ name: t, validations: e, value: a }) => {
  var $;
  const r = G();
  if (!r)
    throw new Error(
      "FormError: You can only use `Messages` inside a `Form` component"
    );
  const n = r.watch(t, a), s = (e == null ? void 0 : e.maxLength) - ((n == null ? void 0 : n.length) || 0), i = ja(r.formState.errors, t), _ = (i == null ? void 0 : i.message) || (($ = i == null ? void 0 : i.root) == null ? void 0 : $.message);
  return !_ && isNaN(s) ? null : /* @__PURE__ */ v("div", { "aria-live": "polite", className: Aa(), children: [
    _ && /* @__PURE__ */ v("small", { className: Ka(), children: [
      /* @__PURE__ */ y(j, { name: "circle-exclamation", style: "solid" }),
      " ",
      _
    ] }),
    !isNaN(s) && /* @__PURE__ */ v("small", { className: Ra(), children: [
      "Characters remaining:",
      " ",
      /* @__PURE__ */ y("span", { className: "font-bold", children: s.toLocaleString() })
    ] })
  ] });
};
La.styles = z;
export {
  La as M,
  Pe as _,
  De as a,
  ea as b,
  D as c,
  k as d,
  re as e,
  ct as f,
  g as i
};
